import React, {useContext, useEffect, useRef, useState} from "react";

import {PlayerContext, PlayerContextDispatch, STATUS_ACTION, STOP, VOLUME_ACTION} from "../PlayerReducer";

import {Skip, SkipReference} from "./Skip";
import {Attributes, Audio as AudioElement, AudioReference} from "./Audio";
import {useAdv} from "./useAdv";
import {usePlaying} from "./usePlaying";
import {Sources} from "./Source";
import {VPaid} from "../Advertisement";
import {useSrc} from "./useSrc";
import classnames from 'classnames';


const Item = () => {

    const state = useContext(PlayerContext);
    const dispatch = useContext(PlayerContextDispatch);


    const skipReference = useRef<SkipReference | null>(null);
    const audioReference = useRef<AudioReference | null>(null);


    const [adv, setAdv] = useAdv({...state, ...{dispatch}});
    const [pingPlayed, setPingPlayed] = useState(adv === false);

    const srcs = useSrc({
        station: state.station,
        streams: state.streams
    })

    const addTime = usePlaying({...state, dispatch}, adv);

    let sources: Sources = [{
        src: 'https://radia.cz/build/ping.mp3',
        type: 'audio/mpeg'
    }];

    let renderSkip = () => {
        return <></>;
    }

    let renderIframe = () => {
        return <></>;
    }


    useEffect(() => {
        if (srcs === false)
            dispatch({
                type: STATUS_ACTION,
                payload: STOP
            });
    }, [srcs]);

    const audioProps: Attributes = {
        sources: sources, domconsole: () => {
        }, volume: 0.3, onError: () => {
            setPingPlayed(true)
        }, onEnded: (ev) => {

            setPingPlayed(true);
        }
    };
    let isAdv = false;
    if (pingPlayed) {
        switch (adv) {
            case false:
                if (srcs) {
                    // prehravani podcastu
                    sources = srcs;

                    Object.assign(audioProps, {
                        ...audioProps,
                        sources,
                        volume: state.volume,
                        onEnded: () => {
                            dispatch({
                                type: STATUS_ACTION,
                                payload: STOP
                            });
                        },
                        onLoadedData: (event)=>{
                            console.log(event);
                        },

                        onError: () => {
                            dispatch({
                                type: STATUS_ACTION,
                                payload: STOP
                            });
                        },
                        onLoadedMetadata: (event) => {

                        },
                        onTimeUpdate: (event) => {
                            addTime(event.timeStamp);
                        }
                    } as Attributes);
                }
                break;
            case undefined:
                //cekani na stazeni reklamy
                break;
            default:
                isAdv = true;
                renderSkip = () => {
                    return <Skip ref={skipReference}
                                 volume={state.volume}
                                 silent={(silent) => {
                                     if (silent)
                                         dispatch({
                                             type: VOLUME_ACTION,
                                             payload: 0
                                         })
                                     else
                                         dispatch({
                                             type: VOLUME_ACTION,
                                             payload: 1
                                         })

                                 }}
                                 skip={() => {
                                     setAdv(false);
                                     dispatch({
                                         type: VOLUME_ACTION,
                                         payload: 1
                                     });
                                 }}/>
                }
                if (adv.type === "VIDEOPROPS") {
                    // pokud je(jsou) to video soubor(y), to je hlavne u reklamy
                    sources = adv.sources;
                    if (state.volume === 0 && !adv.vastData.vastTracker.muted) {
                        adv.vastData.vastTracker.setMuted(true);
                        //state.domconsole(false, 'mute');
                    } else if (state.volume !== 0 && adv.vastData.vastTracker.muted) {
                        adv.vastData.vastTracker.setMuted(false);
                        //state.domconsole(false, 'unmute');
                    }
                    Object.assign(audioProps, {
                        ...audioProps,
                        sources: sources,
                        className: 'video-advertisement',
                        width: adv.width,
                        height: adv.height,
                        style: adv.style,
                        volume: state.volume,
                        onClick: () => {
                            adv.vastData.vastTracker.click();
                        },
                        onEnded: () => {
                            adv.vastData.vastTracker.complete();
                            setAdv(false);
                            dispatch({
                                type: VOLUME_ACTION,
                                payload: 1
                            });
                        },
                        onLoadedMetadata: (event) => {
                            if (!adv.vastData.vastTracker.assetDuration) {
                                const duration = audioReference.current?.duration();
                                if (duration)
                                    adv.vastData.vastTracker.setDuration(duration);
                            }
                            skipReference.current?.duration(adv.vastData.vastTracker.assetDuration);
                        },
                        onError: () => {
                            setAdv(false);
                            dispatch({
                                type: VOLUME_ACTION,
                                payload: 1
                            });
                        },
                        onTimeUpdate: (event) => {
                            const cur = audioReference.current?.currentTime();
                            if (cur) {
                                adv.vastData.vastTracker.setProgress(cur);
                                skipReference.current?.time(cur);
                            }
                        }
                    } as Attributes);

                } else {
                    // pro vpaid se pouzije primo udelany element
                    Object.assign(audioProps, {
                        style: {
                            display: 'none'
                        }
                    });
                    renderIframe = () => {

                        return <div className={'radiacz-iframe'} style={{width: adv.width+'px', height: adv.height +'px'}}><VPaid {...adv} adStart={() => {
                            skipReference.current?.start(10);
                            //this.skipTag?.start(10);
                        }} complete={() => {
                            setAdv(false);
                            dispatch({
                                type: VOLUME_ACTION,
                                payload: 1
                            });
                        }} volume={state.volume}/></div>
                    }
                }
        }
    }


    return <div className={classnames({'radiacz-advertisement': isAdv})}>
        <div className={'radiacz-player'}>
            <AudioElement ref={audioReference} {...audioProps}/>
            {renderSkip()}
            {renderIframe()}

        </div>
    </div>



}


export const Audio = () => {
    const {
        station,
        status
    } = useContext(PlayerContext);

    if (!station || status === 'STOP')
        return <></>;

    return <Item key={station.stationId}/>


}